import { ApiCore } from '@/services/api/utils/core.js'
import { apiProvider } from '@/services/api/utils/provider.js'
import { handleError, handleResponse } from '@/services/api/utils/response.js'
import axios from 'axios'

const url = 'org/enroll'

const api = new ApiCore({
	index: true,
	create: true,
	url: url
})


api.getRequest = () => {
	return axios
		.get(`${apiProvider.BASE_URL}/my-info/config`)
		.then(handleResponse)
		.catch(handleError);
}

api.getRequestParams = (params) => {
	return axios
		.get(`${apiProvider.BASE_URL}/my-info/entity-data?` + params)
		.then(handleResponse)
		.catch(handleError);
}

api.postRequestParams = (params) => {
	return axios
		.post(`${apiProvider.BASE_URL}/org/enroll`, params)
		.then(handleResponse)
		.catch(handleError);
}

api.putRequestParams = (id, params) => {
	return axios
		.put(`${apiProvider.BASE_URL}/org/enroll/${id}`, params)
		.then(handleResponse)
		.catch(handleError);
}


export default api
